import { createHandleChange } from "../../../utils/calculator/createHandleChange";
import { getInputWidth } from "../../../utils/calculator/getInputWidth";
import style from "../calculator.module.css";
function EditableLink(props) {
  const { formData, setFormData, statusMode } = props;
  const handleChange = createHandleChange(setFormData);
  return (
        <div>
            <input

                type="text"
                name={"part_link"}
                placeholder={"Link Da Calculadora..."}
                value={formData["part_link"]}
                onChange={
                    (e) => {
                        const regex = /^[a-zA-Z0-9-_]*$/;
                        if (regex.test(e.target.value)) {
                            handleChange(e);
                        }
                    }
                }
                style={{
                    minWidth: "200px",
                    width: `${getInputWidth(formData["part_link"])}px`,
                    maxWidth: '80vw',
                    transition: 'width 0.2s ease',
                }}
                className={`align-self-center form-control ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}  `}
            />
        </div>
    );
}
export {
  EditableLink
};